import { PublicCategoryResponse } from '@ahora-patagonia/contracts';
import { ApiError, type ApiClient } from '../../../shared/http/ApiClient.js';
import { fixtureCategoria, fixturesActivos } from '../../../shared/fixtures/publicFixtures.js';
import type { CategoriaData } from '../entities/CategoriaData.js';

/** Acceso a una sección con sus notas paginadas de a 12 ("Ver más"). */
export class CategoriaRepository {
  constructor(private readonly api: ApiClient) {}

  async porUrlKey(urlKey: string, page = 1): Promise<CategoriaData> {
    const fixtures = fixturesActivos();
    if (fixtures) {
      const data = fixtureCategoria(urlKey, fixtures);
      // El mismo 404 que la API: una sección desconocida no existe tampoco en fixtures.
      if (!data) throw new ApiError('PUBLIC_CATEGORIA_NO_ENCONTRADA', 'No existe la sección', 404);
      return data;
    }
    const data = await this.api.get<unknown>(
      `/public/categories/${encodeURIComponent(urlKey)}?page=${page}`,
    );
    return PublicCategoryResponse.parse(data);
  }
}
